module.exports = __webpack_public_path__ + "media/images/badge/fedelissimo-258e0cf1a4231db6b6100881497137ba.png";